<template>

        <div :id="problem.id" :class="'accordion-section'+ (problem.open?' active':'')" v-if="problem.data">
          <div class="accordion-header" @click="problem.open = !problem.open">
            <div class="accordion-title">
              <i :class="'bi '+ problem.ico"></i> {{ problem.name }}
              <span :class="'accordion-badge ' + (problem.count <= 0?'success':problem.count<2?'info':problem.count<20?'warning':'critical')">{{ problem.count }} неактивных</span>
            </div>
            <div class="accordion-icon">▼</div>
          </div>
          <div :class="'accordion-content'+ (problem.open?' active':'')">
            <div class="metric-group">
              <div class="metric-item">
                <div class="metric-value">{{ problem.data.inactive_users_count }}</div>
                <div>Неактивные >{{ problem.data.days_inactive_threshold }}дн</div>
              </div>
              <div class="metric-item">
                <div class="metric-value">{{ problem.data.never_logged_count }}</div>
                <div>🆕 Никогда не входили</div>
              </div>
            </div>

            <h3>📅 Распределение по сроку неактивности</h3>
            <div class="simple-chart">
              <div class="chart-bar">
                <div class="chart-label">30-60 дней</div>
                <div class="chart-line">
                  <div class="chart-fill"
                       :style="{width: $widthratio(problem.data.inactivity_stats['30_60_days'], problem.data.inactive_users_count) + '%', background: '#f39c12'}">
                    {{ problem.data.inactivity_stats['30_60_days'] }}
                  </div>
                </div>
              </div>
              <div class="chart-bar">
                <div class="chart-label">60-90 дней</div>
                <div class="chart-line">
                  <div class="chart-fill"
                        :style="{width: $widthratio(problem.data.inactivity_stats['60_90_days'], problem.data.inactive_users_count) + '%', background: '#e67e22'}">
                    {{ problem.data.inactivity_stats['60_90_days'] }}
                  </div>
                </div>
              </div>
              <div class="chart-bar">
                <div class="chart-label">Более 90 дней</div>
                <div class="chart-line">
                  <div class="chart-fill danger"
                        :style="{width: $widthratio(problem.data.inactivity_stats['90_plus_days'], problem.data.inactive_users_count) + '%'}">
                    {{ problem.data.inactivity_stats['90_plus_days'] }}
                  </div>
                </div>
              </div>
            </div>

            <h3 class="pt-3">👤 Топ-20 неактивных пользователей</h3>
            <table class="data-table">
              <thead>
              <tr>
                <th>Username</th>
                <th>Email</th>
                <th>Последний вход</th>
                <th>Дней неактивен</th>
                <th>Регистрация</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="user in problem.data.inactive_users_details">
                <td><strong>{{ user.username }}</strong></td>
                <td>{{ user.email }}</td>
                <td>{{user.last_login?$moment(user.last_login).format("DD.MM.YYYY"):'-'}}</td>
                <td style="color: #e74c3c;">{{ user.days_inactive }} дн.</td>
                <td>{{user.date_joined?$moment(user.date_joined).format("DD.MM.YYYY"):'-'}}</td>
                <td><a :href="`/admin/profiles/${user.id}/`" target="_blank" style="color: #3498db;">✏️</a>
                </td>
              </tr>
              </tbody>
            </table>

            <h3 class="pt-3">👤 Пользователи ни разу не входившие в сервис</h3>
            <table class="data-table">
              <thead>
              <tr>
                <th>Username</th>
                <th>Email</th>
                <th>Регистрация</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="user in problem.data.never_logged_details">
                <td><strong>{{ user.username }}</strong></td>
                <td>{{ user.email }}</td>
                <td>{{user.date_joined?$moment(user.date_joined).format("DD.MM.YYYY"):'-'}}</td>
                <td><a :href="`/admin/profiles/${user.id}/`" target="_blank" style="color: #3498db;">✏️</a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>


</template>

<script>

export default {
  name: 'UsersInfo',
  data() {
    return {}
  },
  props: {
    problem: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">

</style>